/**
 * DetailSection - Wrapper for sections with consistent spacing and optional title
 */
export default function DetailSection({ title, children, className = '' }) {
  return (
    <div className={`space-y-3 max-lg:space-y-2 ${className}`}>
      {title && <h3 className="text-lg max-lg:text-base font-bold text-white">{title}</h3>}
      {children}
    </div>
  );
}
